// client/src/routes/app/banking/index.tsx — SCR-BANK-001 · BANK-004 (04 §8.6).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its „all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed.
//
// The guard MOVED, from `Banking.Import` to `Banking.Read`. UI-003 gated the placeholder on the
// upload permission because there was no screen and therefore no reading to protect; now there
// is, and 03 §17.1 grants the accountant role `Banking.Read` WITHOUT `Banking.Import` — an
// accountant who reads the history and cannot upload is the exact case the two codes exist to
// separate, and the old gate rendered SCR-SYS-403 at them. The upload panel keeps the stricter
// permission inside the screen. See DEVIATIONS D-725.
//
// The two other screens 04 §8.6 lists — SCR-BANK-002's import wizard and SCR-BANK-003's
// reconciliation board — have no route here and no placeholder either (D-720).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ImportHistory } from '@/features/banking/ImportHistory';
import { bankImportSearchSchema, type BankImportSearch } from '@/features/banking/search';

export const Route = createFileRoute('/app/banking/')({
  validateSearch: bankImportSearchSchema,
  component: BankingScreen,
});

function BankingScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Banking.Read">
      <ImportHistory
        search={search}
        onSearchChange={(next: (previous: BankImportSearch) => BankImportSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
